import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 23px;
  height: 100%;
  gap:20px;
  min-height: 0;
  overflow: hidden; /* list should scroll, bars stay visible */
`;

export const AddBox = styled.div`
  min-width:100px;
  display: flex;
  gap: 4px;
  align-items: center;

  span {
    font-family: SF Pro Display;
    font-weight: 600;
    font-style: Semibold;
    font-size: 13px;
    line-height: 18px;
    color:#6777FF;
  }
`;

export const HeadBox = styled.div`
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
`;

export const TabeBox = styled.div`
  width: 100%;
  height: 39px;
  border-radius: 10px;
  background: #F6F6F6;
  display: flex;
  align-items: center;
  padding-left:21px;
`;

export const Title = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  line-height: 18px;
  color: #7C7C7C;
`;

export const AppleBox = styled.div`
  padding-left: 181px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  line-height: 18px;
  color: #7C7C7C;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Social = styled.div`
  padding-left: 93px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  line-height: 18px;
  color: #7C7C7C;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Channel = styled.div`
  padding-left: 107px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  line-height: 18px;
  color: #7C7C7C;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Content = styled.div``;

export const ScrollableList = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  position: relative;

  /* hide scrollbar while keeping scroll */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Row = styled.div`
  width:100%;
  height:50px;
  border-bottom:1px solid #E0E0E0;
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding-left:21px;

  @media (max-width: 768px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const Name = styled.div`
  min-width:100px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 15px;
  color: #000000;
`;

export const AppleSpotify = styled.div`
  height:100%;
  padding-left:92px;
  display:flex;
  align-items: center;
  gap:7px;
  width:165px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const AppleSpotifyBox = styled.div`
  height:100%;
  display:flex;
  align-items: center;
`;

export const SocialBox = styled.div`
  height:100%;
  padding-left:60px;
  display:flex;
  gap:7px;
  width:165px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const YoutubeBox = styled.div`
  height:100%;
  padding-left:55px;
  display:flex;
  gap:7px;
  width:165px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const EditBox = styled.div`
  padding-left:178px;
  display:flex;
  gap:7px;
  cursor:pointer;

  @media (max-width: 768px) {
    padding-left: 0;
  }
`;

export const Box = styled.div`
  height:100%;
  position: relative;
  cursor:pointer;
  display: flex;
  align-items: center;
  &:hover .dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const Dropdown = styled.div`
  display: none;
  position: absolute;
  top: -40px;
  left: -5px;
  width: 157px;
  height: 45px;
  border-radius: 15px;
  background: #E2E5FF;
  z-index:9;
  padding:12px 10px 11px 13px;

  span {
    font-family: SF Pro Display;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    line-height: 20px;
    text-decoration: underline;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index:9999;
`;

export const Modal = styled.div`
  width: 520px;
  height: 139px;
  opacity: 1;
  border-radius: 10px;
  background: #FFFFFF;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TextBox = styled.div`
  width:374px;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: SF Pro Display;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 16px;
  color: #000000;
`;

export const ButtonBox = styled.div`
  display:flex;
  margin-top: 10px;
  cursor:pointer;
`;

export const NoBox = styled.div`
  width: 60px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
`;

export const YesBox = styled.div`
  width: 60px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #6777FF;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: #FFFFFF;
`;

export const PaginatorWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const PaginatorBar = styled.div`
  flex: 0 0 auto;
  width: calc(100% + 46px);
  margin: 0 -23px; /* full-bleed (cancel Container padding) so paginator fits in one row */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background: #ffffff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);

  /* Keep rows-per-page dropdown on the right and prevent wrapping */
  .p-paginator {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    padding-right: 88px;
    flex-wrap: nowrap;
    align-items: center;
  }

  .p-paginator-pages {
    white-space: nowrap;
  }

  .p-paginator-first,
  .p-paginator-prev,
  .p-paginator-next,
  .p-paginator-last {
    flex: 0 0 auto;
  }

  .p-paginator-rpp-options,
  .p-paginator .p-dropdown {
    position: absolute;
    right: 10px;
  }

  /* Mobile: paginator section should have no side padding */
  @media (max-width: 768px) {
    padding: 10px 0;

    .p-paginator {
      /* Keep space for the rows-per-page dropdown so Next/Last buttons stay visible */
      padding-right: 96px;
    }

    .p-paginator-rpp-options,
    .p-paginator .p-dropdown {
      right: 0;
    }

    /* Mobile: make paginator controls slightly more compact to avoid wrapping */
    .p-paginator .p-paginator-pages .p-paginator-page,
    .p-paginator-first,
    .p-paginator-prev,
    .p-paginator-next,
    .p-paginator-last {
      min-width: 32px;
      height: 32px;
    }
  }
`;

export const LoadingBox = styled.div`
  position: relative;
  height:70vh;
`;

export const Loading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  border:1px solid #E0E0E0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 333px;
  height: 43px;

  @media (max-width: 768px) {
    width: 70%;
    min-width: 160px;
  }

  `;

export const SearchIcon = styled.span`
  position: absolute;
  left: 10px;
  top: 25px;
  transform: translateY(-50%);
  font-size: 16px;
  color: #888;
`;
